import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { animationClasses } from "@/utils/animations";
import Navbar from "@/components/common/Navbar";
import Footer from "@/components/home/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <div className="flex-grow flex items-center justify-center py-20">
        <div className="text-center max-w-lg px-4">
          <h1 className="text-8xl font-bold mb-6 text-[#C05B2A] animate-fade-up">404</h1>
          <p className="text-2xl font-semibold text-gray-800 mb-4 animate-fade-up animation-delay-200">Oops! Page not found</p>
          <p className="text-gray-600 mb-8 animate-fade-up animation-delay-300">
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <a 
            href="/" 
            className="inline-block px-6 py-3 bg-[#C05B2A] text-white rounded-lg hover:bg-[#A34A21] transition-colors animate-fade-up animation-delay-400"
          >
            Return to Home
          </a>
          <div className="mt-12 animate-fade-up animation-delay-500">
            <img 
              src="/logo.png" 
              alt="Rion Wildlife Safaris Logo" 
              className="h-16 mx-auto"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
